import classNames from 'classnames'
import React from 'react'
import styles from './dropdown.module.css'
import { DropdownButton } from 'src/shared'
import { Modal } from 'src/shared/hooks/use_modal/types'

export const Dropdown = ({
  id,
  modal,
  children,
  limitedWidth,
  label,
}: {
  id: string
  modal: Modal
  children: React.ReactNode
  limitedWidth?: boolean
  label: string
}) => {
  return (
    <div id={id} className={classNames(styles.container, limitedWidth && styles.limitedWidth)}>
      <DropdownButton onClick={modal.show}>{label}</DropdownButton>
      {modal.background}
      {modal.active ? (
        <div className={classNames(styles.modal, limitedWidth && styles.topPositioned)}>{children}</div>
      ) : null}
    </div>
  )
}
